(function () {
  'use strict';

  const drawer = document.getElementById('bx-cart-drawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.bx-drawer__panel');
  const itemsEl = drawer.querySelector('[data-bx-cart-items]');
  const footEl = drawer.querySelector('[data-bx-cart-foot]');
  const countEls = document.querySelectorAll('[data-bx-cart-count]');
  const subtotalEl = drawer.querySelector('[data-bx-cart-subtotal]');

  function formatMoney(cents) {
    const euros = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20ac' + euros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bx-drawer-locked');
    setTimeout(() => panel && panel.focus(), 100);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bx-drawer-locked');
  }

  function updateCountBadges(count) {
    document.querySelectorAll('[data-bx-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    const headerBadge = document.querySelector('.bx-header__badge');
    if (headerBadge) {
      headerBadge.textContent = count;
      headerBadge.style.display = count > 0 ? '' : 'none';
    }
  }

  function renderItems(cart) {
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML =
        '<div class="bx-drawer__empty" data-bx-empty>' +
          '<div class="bx-drawer__empty-icon" aria-hidden="true">' +
            '<svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M9 17 H51 L45 44 H15 Z" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linejoin="round"/>' +
              '<circle cx="21" cy="51" r="3.5" stroke="currentColor" stroke-width="2.5" fill="none"/>' +
              '<circle cx="40" cy="51" r="3.5" stroke="currentColor" stroke-width="2.5" fill="none"/>' +
              '<path d="M6 11 H14 L16 17" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</div>' +
          '<p class="bx-drawer__empty-text">Dein Warenkorb ist noch leer.</p>' +
          '<a href="/collections/all" class="bx-btn bx-btn-primary bx-btn-lg" data-bx-drawer-close>ZU DEN MODELLEN</a>' +
        '</div>';
      footEl.hidden = true;
      return;
    }

    footEl.hidden = false;
    itemsEl.innerHTML = cart.items.map((item, i) => {
      const idx = i + 1;
      const title = escapeHtml(item.product_title);
      const safeUrl = escapeHtml(item.url);
      const safeKey = escapeHtml(item.key);
      const imgSrc = item.image ? escapeHtml(item.image.replace('{width}', '160')) : '';
      const imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy" width="160" height="160">'
        : '<div class="bx-drawer-item__placeholder">' + escapeHtml(item.product_title.slice(0, 4)) + '</div>';
      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="bx-drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
      return '' +
        '<article class="bx-drawer-item" data-bx-line="' + idx + '" data-bx-key="' + safeKey + '">' +
          '<a href="' + safeUrl + '" class="bx-drawer-item__media">' + imgHtml + '</a>' +
          '<div class="bx-drawer-item__body">' +
            '<a href="' + safeUrl + '" class="bx-drawer-item__title">' + title + '</a>' +
            variantHtml +
            '<div class="bx-drawer-item__row">' +
              '<div class="bx-drawer-qty">' +
                '<button type="button" class="bx-drawer-qty__btn" data-bx-qty-dec data-bx-line="' + idx + '" aria-label="Menge verringern">\u2212</button>' +
                '<span class="bx-drawer-qty__value">' + item.quantity + '</span>' +
                '<button type="button" class="bx-drawer-qty__btn" data-bx-qty-inc data-bx-line="' + idx + '" aria-label="Menge erh\u00f6hen">+</button>' +
              '</div>' +
              '<span class="bx-drawer-item__price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="bx-drawer-item__remove" data-bx-line-remove data-bx-line="' + idx + '">Entfernen</button>' +
          '</div>' +
        '</article>';
    }).join('');
  }

  function refreshCart(openAfter) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        renderItems(cart);
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
        updateCountBadges(cart.item_count);
        if (openAfter) openDrawer();
        return cart;
      });
  }

  async function changeLine(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!response.ok) throw new Error('cart change failed');
      const cart = await response.json();
      renderItems(cart);
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      updateCountBadges(cart.item_count);
    } catch (e) {
      console.error('bx-cart-drawer change error:', e);
    }
  }

  async function addFromForm(form) {
    const submitBtn = form.querySelector('[type="submit"]');
    const originalBtnText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'WIRD HINZUGEF\u00dcGT\u2026';
    }
    try {
      const formData = new FormData(form);
      const response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.description || 'add to cart failed');
      }
      await refreshCart(true);
    } catch (e) {
      console.error('bx-cart-drawer add error:', e);
      alert('Konnte nicht zum Warenkorb hinzugef\u00fcgt werden: ' + e.message);
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
      }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches('form[action$="/cart/add"], form[action$="/cart/add.js"]')) return;
    e.preventDefault();
    addFromForm(form);
  });

  drawer.addEventListener('click', (e) => {
    if (e.target.closest('[data-bx-drawer-close]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  drawer.addEventListener('click', (e) => {
    const dec = e.target.closest('[data-bx-qty-dec]');
    const inc = e.target.closest('[data-bx-qty-inc]');
    const rem = e.target.closest('[data-bx-line-remove]');
    if (dec) {
      const line = parseInt(dec.dataset.bxLine, 10);
      const valueEl = dec.parentElement.querySelector('.bx-drawer-qty__value');
      const newQty = Math.max(0, parseInt(valueEl.textContent, 10) - 1);
      changeLine(line, newQty);
    } else if (inc) {
      const line = parseInt(inc.dataset.bxLine, 10);
      const valueEl = inc.parentElement.querySelector('.bx-drawer-qty__value');
      const newQty = parseInt(valueEl.textContent, 10) + 1;
      changeLine(line, newQty);
    } else if (rem) {
      const line = parseInt(rem.dataset.bxLine, 10);
      changeLine(line, 0);
    }
  });

  document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(a => {
    if (a.closest('.bx-drawer')) return;
    if (a.classList.contains('bx-header__cart-icon') || a.dataset.bxCartToggle === '' || a.closest('.bx-header__icon')) {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        refreshCart(true);
      });
    }
  });

})();
